import React, { PureComponent } from 'react';
import Icon from '~/core/scripts/components/Icon';

const link = `${ARTICLE_CONFIG.baseUrl}${ARTICLE_CONFIG.teaserLink}`;
const title = ARTICLE_CONFIG.teaserTitle || 'Alle Ergebnisse';
const subtitle = ARTICLE_CONFIG.teaserSubtitle || 'Alle Ergebnisse für Deutschland und Europa';
const imgSrc = ARTICLE_CONFIG.teaserImgPath || 'images/eu2019.png';

class MobileTeaser extends PureComponent {
  render() {
    return (
      <div className="mobileteaser">
        <a className="mobileteaser__link" href={link} target="_blank">
          <img src={imgSrc} className="mobileteaser__img" />
          <div className="mobileteaser__content">
            <div className="mobileteaser__title">{title} <Icon type="arrow-left"/></div>
            <div className="mobileteaser_subtitle">{subtitle}</div>
          </div>
        </a>
      </div>
    );
  }
}

export default MobileTeaser;
